/**
 * Vertex attribute types of a vertex in a ModelMesh.
 */
export enum VertexAttribute {
  /** Vertex position. */
  Position = "POSITION",
  /** Vertex normal. */
  Normal = "NORMAL",
  /** Vertex color. */
  Color = "COLOR_0",
  /** Vertex tangent. */
  Tangent = "TANGENT",
  /** Vertex bone weight. */
  BoneWeight = "WEIGHTS_0",
  /** Vertex bone index. */
  BoneIndex = "JOINTS_0",
  /** Vertex UV. */
  UV = "TEXCOORD_0",
  /** Vertex UV1. */
  UV1 = "TEXCOORD_1",
  /** Vertex UV2. */
  UV2 = "TEXCOORD_2",
  /** Vertex UV3. */
  UV3 = "TEXCOORD_3",
  /** Vertex UV4. */
  UV4 = "TEXCOORD_4",
  /** Vertex UV5. */
  UV5 = "TEXCOORD_5",
  /** Vertex UV6. */
  UV6 = "TEXCOORD_6",
  /** Vertex UV7. */
  UV7 = "TEXCOORD_7"
}
